import React, { useEffect, useState } from 'react'
import { Check2, X } from 'react-bootstrap-icons'
import MessageTemple from '../../../../../../../../libs/api/services/MessageTemple'
import MessagingServiceProvider from '../../../../../../../../libs/api/services/MessagingServiceProvider'
import Questionnaire from '../../../../../../../../libs/api/services/Questionnaire'
import ToDoListService from '../../../../../../../../libs/api/services/ToDoListService'
import { FacilityBreakdownQuestionnaireComponent } from '../../../QuestionnaireForms/FacilityBreakdownQuestionnaireComponent'

export default function BasicTableTaskPropertiesComponent({ props }) {
    return !['Task Details'].includes(props.type.type) && <tr>
        <td>{props.type.type}</td>
        <td>{
            {
                'ALLOCATE_TO_DO': <ToDoListPreview props={JSON.parse(props.value)} />,
                'SET_STATUS_TO_DO': <ToDoListPreview props={JSON.parse(props.value)} />,
                'Task Details': <></>,
                'Message Template': <MessageTemplatePreview MessageTemplateID={JSON.parse(props.value)} />,
                'Service Provider': <MessagingServiceProviderPreview ServiceProviderID={JSON.parse(props.value)} />,
                'NOTIFICATION_DETAILS': <NotificationPreview Details={JSON.parse(props.value)} />,
                'LOG_PATIENT_HISTORY': <LogPatientHistoryPreview Details={JSON.parse(props.value)} />,
                'Form': <FormPreview QuestionnaireID={JSON.parse(props.value)} />,
                'Questionnaire': <FormPreview QuestionnaireID={JSON.parse(props.value)} />,
                'ADD_CALENDAR_DETAILS': <AddCalendarDetailsPreview Details={JSON.parse(props.value)} />,
                'UPDATE_CALENDAR_DETAILS': <UpdateCalendarDetailsPreview Details={JSON.parse(props.value)} />,
            }[props.type.type] || <UnknownPreview type={props.type.type} props={JSON.parse(props.value)} /> // `Unknown Property Type (${props.type.type})`
            // props.value
        }</td>
    </tr>
    // return (
    //     <div>
    //         {JSON.stringify(props)}
    //         Task PRops
    //     </div>
    // )
}

const ToDoListPreview = ({ props }) => {
    const [details, setDetails] = useState()
    useEffect(() => {
        const load = async () =>
            setDetails(props.listDetails && props.listDetails.group ? await ToDoListService.GetToDoList(props.listDetails.group) : { group: 'List not configured' })
        load()
    }, [])
    return (details ? <div>
        {
            details.group ?
                <ul>
                    <li>{details.group}</li>
                    {
                        details.lists &&
                        <li><ul>
                            {
                                details.lists.map(l =>
                                    <>
                                        <li>{l.list}</li>
                                        {
                                            l.items &&
                                            <li><ul>
                                                {l.items.map(i => <li>{i.item} {props.listDetails.item && props.listDetails.item === i.id ? <Check2 /> : <X />}</li>)}
                                            </ul></li>
                                        }
                                    </>
                                )
                            }
                        </ul></li>
                    }
                </ul>
                : <></>

        }
    </div> : 'Loading To Do List Details')
}

export const MessageTemplatePreview = ({ MessageTemplateID, Cached }) => {
    const [details, setDetails] = useState()
    useEffect(() => {
        const load = async () =>
            Cached ? setDetails(Cached)
                :
                setDetails(await MessageTemple.GetMessageTemplates(MessageTemplateID).catch(e => console.error(`ISSUES(BX37): Failed to load Message Template ${e.message} ${MessageTemplateID}`)))
        load()
    }, [])
    return (<div>{details && details.audience ?
        <div>
            <div>{details.name}</div>
            <div>{details.audience.audienceType ? details.audience.audienceType : ''}</div>
            <div>{details.serviceType.type}</div>
            <div>{details.isDeleted && 'Deleted'}</div>
            <div dangerouslySetInnerHTML={{ __html: details.templateHTML }} />
            {/* JSON.stringify(Object.keys(details)  */}
        </div>
        : 'Loading Preview'}

    </div>)
}
const MessagingServiceProviderPreview = ({ ServiceProviderID }) => {
    const [details, setDetails] = useState()
    useEffect(() => {
        const load = async () =>
            setDetails(await MessagingServiceProvider.GetServices(ServiceProviderID))
        load()
    }, [])
    return (<div>{details ?
        <div>
            {JSON.stringify(Object.keys(details))}
        </div>
        : 'Loading Preview'}

    </div>)
}
export const NotificationPreview = ({ Details }) => {
    if (!Details) return <div>Notification not configured</div>
    return (<div>
        <div>{Details.recipient ? Details.recipient : 'No Recipient Specified'}</div>
        {Details.Notification && <div dangerouslySetInnerHTML={{ __html: Details.Notification.html }} />}
    </div>)
}
const LogPatientHistoryPreview = ({ Details }) => {
    return (<div>{`Log entry : ${Details.event} under category ${Details.category} to a patients history`}</div>)
}
export const FormPreview = ({ QuestionnaireID, Cached }) => {
    const [details, setDetails] = useState()
    useEffect(() => {
        const load = async () =>
            Cached ? setDetails(Cached)
                :
                setDetails(await Questionnaire.GetQuestionnaire(QuestionnaireID))
        load()
    }, [QuestionnaireID, Cached])
    return (<div>{details ? <FacilityBreakdownQuestionnaireComponent questionnaire={details} /> : 'Loading Preview'}

    </div>)
}
const AddCalendarDetailsPreview = ({ Details }) => {
    return (<div>
        <div>{Details.recipient && Details.recipient}</div>
        <div>{Details.summary && Details.summary}</div>
        <div>{Details.status && Details.status}</div>
        <div>{Details.details && Details.details}</div>
        <div>{DateTimeConfigToString({
            CreateForWhen: Details.CreateForWhen,
            CreateForDOW: Details.CreateForDOW,
            CreateForWhenTime: Details.CreateForWhenTime,
            CreateForWhenTimeHH: Details.CreateForWhenTimeHH,
            CreateForWhenTimeMM: Details.CreateForWhenTimeMM,
            CreateForDuration: Details.CreateForDuration,
        })}</div>
    </div>)
}
const UpdateCalendarDetailsPreview = ({ Details }) => {
    return (<div>
        {Details.calendarToUpdated && <div>{`Update ${Details.recipient} calendars where calendar type is ${Details.calendarToUpdated.eventName} ${Details.occourance && `on the ${Details.occourance}`} ${Details.summary ? `and change the summary to ${Details.summary}` : ''} ${Details.status ? `and change the status to ${Details.status}` : ''} ${Details.details ? `and change the details to ${Details.details}` : ''} ${Details.CreateForWhen && `and update the event to occour ${DateTimeConfigToString({
            CreateForWhen: Details.CreateForWhen,
            CreateForDOW: Details.CreateForDOW,
            CreateForWhenTime: Details.CreateForWhenTime,
            CreateForWhenTimeHH: Details.CreateForWhenTimeHH,
            CreateForWhenTimeMM: Details.CreateForWhenTimeMM,
            CreateForDuration: Details.CreateForDuration,
        })}`}
        `.trim().replace('  ', ' ')}</div>}
    </div>)
}
const UnknownPreview = ({ type, props }) => {
    return (<div>Unkown type {type} <pre>{JSON.stringify(props, '\t', 2)}</pre></div>)
}

const DateTimeConfigToString = (config) => {
    const DateToHR = () => {
        if (!config.CreateForWhen)
            return ('Day specification has not been configured or is invalid')
        switch (config.CreateForWhen) {
            case 'Same day': return 'On the Same Day';
            default: return `Unknown Day Filter ${config.CreateForWhen}`
        }
    }
    const TimeToHR = () => {
        if (!config.CreateForWhenTime)
            return ('Time specification has not been configured or is invalid')
        var time = ''
        switch (config.CreateForWhenTime) {
            case 'Specific time':
                time = `at ${config.CreateForWhenTimeHH ? String(config.CreateForWhenTimeHH).padStart(2, '0') + ':' : 'Unknown Hour'}${config.CreateForWhenTimeMM ? String(config.CreateForWhenTimeMM).padStart(2, '0') : 'Unknown Minute'}`; break;
            default: return `Unknown Time Filter ${config.CreateForWhenTime}`
        }
        if (config.CreateForDuration)
            time += ` for the duration of ${config.CreateForDuration} minutes`
        return time
    }
    return (`${DateToHR()} ${TimeToHR()}`)
}